import { LenderName } from '@nemuru-eng/js-api-client';

export const COMPANY_CIF_REQUIRED_LENDER_NAMES: LenderName[] = [LenderName.BS];
